<script>
import { ValidationField } from '@/components/ui/validate-form';
import BaseIcon from '@/components/icon.vue';
import BaseInput from '@/components/ui/base-input/base-input.vue';

export default {
  name: 'RegistrationField',
  components: { BaseIcon, BaseInput, ValidationField },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    field: {
      type: String,
      required: true
    },
    submitted: {
      type: Boolean,
      default: false
    },
    showOnlyOneError: ValidationField.props.showOnlyOneError
  }
};
</script>

<template>
  <validation-field
    :hide-errors="!submitted"
    :name="field"
    :show-only-one-error="showOnlyOneError"
    :data-qa="field"
  >
    <template #default="{ id, modelValue, onChange, name, invalid, pristine }">
      <base-input
        :id="id"
        :value="modelValue"
        :name="name"
        :invalid="invalid && submitted"
        :class="[$style.demoInput, { [$style.invalid]: invalid && submitted }]"
        :placeholder="placeholder"
        big
        v-bind="$attrs"
        @input="onChange"
      >
        <template v-if="!invalid && !pristine" #append>
          <base-icon :class="$style.checked" type="checked" />
        </template>
      </base-input>
    </template>
    <template #error="{ error }">
      <span :class="$style.error">
        <slot name="error" :message="error.message">
          {{ error.message }}
        </slot>
      </span>
    </template>
  </validation-field>
</template>

<style module>
.demoInput {
  height: 46px;
  font-size: 20px;
  padding: 0 10px;
  transition: all 300ms;
  background: $whiteColor;
  input {
    font-size: 20px;
    font-family: Graphik, Arial, Tahoma, Verdana, sans-serif;
    color: $textColor;
  }
  &:focus-within {
    border: 1px solid #16bf54;
    box-shadow: 0 0 10px 0 rgba(22, 191, 84, 0.2);
  }
  @media (max-width: 768px) {
    height: 35px;
    padding: 0 15px;
  }
}

.invalid {
  border: 1px solid $red-400;
}

.error {
  font-size: 18px;
  color: $red-400;
  line-height: 25px;
  a {
    color: $red-400;
  }
}

.checked {
  color: #16bf54;
}
</style>

<i18n lang="json">{}</i18n>
